/** Firestore can lag NetInfo: OS thinks we're online before the SDK finishes reconnecting. */
export function isFirestoreClientOfflineLikeError(error: unknown): boolean {
  const code = typeof (error as { code?: string })?.code === 'string' ? String((error as { code?: string }).code) : '';
  const msg = String((error as { message?: unknown })?.message ?? error ?? '');
  if (code === 'unavailable') return true;
  if (code === 'deadline-exceeded') return true;
  if (/client is offline/i.test(msg)) return true;
  if (/Failed to get document/i.test(msg) && /offline/i.test(msg)) return true;
  return false;
}

export function sleepMs(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Short bounded retries while the Firestore client catches up after network restore. */
export async function runWithFirestoreReconnectGrace(fn: () => Promise<void>): Promise<void> {
  let lastError: unknown;
  const maxAttempts = 5;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      await fn();
      return;
    } catch (e) {
      lastError = e;
      if (!isFirestoreClientOfflineLikeError(e) || attempt === maxAttempts - 1) {
        throw e;
      }
      await sleepMs(350 * (attempt + 1));
    }
  }
  throw lastError;
}
